const IllumioVideo = {
    allowVideo: true,
    trainingVideoHashes: null,
    urlSafe: function(string) {
        return string.replace(/ /g, '_').replace(/\//g, '_').toLowerCase()
    },
    videoContainerOnClickHandler: function(event) {
        const wistiaId = this.dataset['id'];
        const hash = this.dataset['hash'];
        IllumioVideo.openVideoPopover(wistiaId, hash, true);
    },
    videoCardOnClickHandler: function(event) {
        const wistiaId = event.currentTarget.dataset['id'];
        const hash = IllumioVideo.urlSafe(event.currentTarget.dataset['title']);
        IllumioVideo.openVideoPopover(wistiaId, hash, true);
    },
    openVideoPopover: function(wistiaId, hash, play) {
        if (IllumioVideo.allowVideo==false) {
            return false
        }
        IllumioVideo.allowVideo = false

        if (Wistia && Wistia.api(wistiaId)) {
            Wistia.api(wistiaId).play()
        } else {
            const container = document.getElementById('wistia_container');
            const video_node = document.createElement('span');
            video_node.classList.add("wistia_embed");
            video_node.classList.add("wistia_async_"+wistiaId);
            video_node.classList.add("popover=true");
            video_node.classList.add("muted=false");
            video_node.classList.add("popoverContent=link");
            container.appendChild(video_node);
            _wq.push({ id: wistiaId, onReady: function(video) {
                video.bind("popovershow", function() {
                    IllumioVideo.allowVideo = true
                    window.history.replaceState(null,null,'#'+hash);
                });
                video.on('popoverhide', function() {
                    window.history.replaceState(null,null,'#')
                })
                video.popover.show()
                if (play) {
                    video.play()
                }
            }});
        }
    }
}

export default IllumioVideo;
